import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { get } from '@eika-infrastruktur/request';

import { KREDITTBANKEN_BASE_URL } from '@/react-query/common';

import { useSession } from '@components/app/Session';
import { CreditCardAccount } from '@generated-types';

const getCreditAccountsList = async () => get<CreditCardAccount[]>(`${KREDITTBANKEN_BASE_URL}/credit-card-accounts`);

export const useCreditAccountsList = ({ enabled }: { enabled: boolean } = { enabled: true }) => {
    const session = useSession();

    return useQuery<CreditCardAccount[]>({
        queryKey: ['v4', 'credit-accounts-list'],
        queryFn: getCreditAccountsList,
        placeholderData: keepPreviousData,
        enabled: !!session.creditProfile && enabled,
    });
};
